// extracted by mini-css-extract-plugin
export default {"tab_container":"tabs_tab_container__pRxi4","scrollbar":"tabs_scrollbar__7RUHk"};